export default values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,62}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  return errors;
};
